import { FaMobileAlt } from "react-icons/fa";

export default function ProductImagePlaceholder({
  variant = "candidat",
  label = "Capture app — à venir",
  aspectRatio = "phone",
  className = "",
}) {
  const isCandidat = variant === "candidat";
  const isPhone = aspectRatio === "phone";

  const gradientClass = isCandidat
    ? "from-brand-primary to-brand-accent1"
    : "from-brand-primaryDark to-brand-accent2";

  const sizeClass = isPhone
    ? "w-48 sm:w-56 lg:w-64 aspect-[9/19]"
    : "w-full aspect-square max-w-xs";

  return (
    <div
      className={`relative rounded-2xl overflow-hidden bg-gradient-to-br ${gradientClass} ${sizeClass} flex flex-col items-center justify-center border border-white/20 shadow-2xl ${className}`}
      aria-hidden="true"
    >
      <div className="absolute inset-4 rounded-xl bg-white/10 backdrop-blur-sm" />
      <FaMobileAlt className="relative z-10 text-white/60 text-4xl sm:text-5xl mb-3" />
      <p className="relative z-10 text-white/70 text-xs sm:text-sm text-center px-4 font-medium">
        {label}
      </p>
    </div>
  );
}
